import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import Technology from './pages/Technology';
import Science from './pages/Science';
import AboutUs from './pages/AboutUs';
import History from './pages/History';
import Contact from './pages/Contact';
import './styles.css';

function App() {
  return (
    <Router>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/science" element={<Science />} />
          <Route path="/team" element={<AboutUs />} />
          <Route path="/history" element={<History />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <Analytics />
    </Router>
  );
}

export default App;
